module.exports = __webpack_public_path__ + "img/sankaku_89_blue.7c6cecf0.png";